import ListIcon from "../icons/ListIcon";
import React, { useEffect, useState } from "react";
import { useMediaPredicate } from "react-media-hook";
import { AnimatePresence } from "framer-motion";
import HamburgerMenuExpanded from "./HamburgerMenuExpanded";
import { Link } from "react-router-dom";
import CustomDropdown from "./CustomDropdown";
import black_logo from "../Images/shared/logos/GalerieLiving_Logotype_W.webp";
import white_logo from "../Images/shared/logos/GalerieLiving_Logotype_K.png";
import XIcon from "../icons/XIcon";
export default function Navbar({
  backgroundColor,
  textColor,
  setNavHoverDim,
  navHoverDim,
}) {
  const [borderColor, setBorderColor] = useState("#D9D9D6");
  const max_width = useMediaPredicate("(min-width: 1000px)");
  const [expandMenu, setExpandMenu] = useState(false);

  // Also drives App.js's page dim/blur overlay, same as an open desktop
  // dropdown does.
  const handleExpand = () => {
    const next = !expandMenu;
    setExpandMenu(next);
    setNavHoverDim(next);
  };

  useEffect(() => {
    if (textColor === "black") {
      setBorderColor("#D9D9D6");
    } else {
      setBorderColor("rgba(217, 217, 214, 0.3)");
    }
  }, []);

  // Over the hero, each dropdown panel draws one tint layer that also
  // extends up behind this header (see .custom-dropdown-menu.tinted) — a
  // single element, so the header and dropdown can't differ in shade or
  // fade timing.
  const tintedDropdowns = backgroundColor === "transparent";

  return (
    <>
      {max_width ? (
        <>
          <div
            className="nav-bar"
            style={
              navHoverDim && backgroundColor !== "transparent"
                ? { background: backgroundColor, borderBottom: `1px solid ${borderColor}` }
                : { background: backgroundColor }
            }
          >
            <Link
              to="/"
              aria-label="galerie-logo"
              className="galerie-logo-link"
              data-testid="nav-galerie-logo"
            >
              {textColor === "white" ? (
                <>
                  <img
                    alt=""
                    className="galerie-logo"
                    src={black_logo}
                    width="300"
                    height="169"
                  />
                </>
              ) : (
                <>
                  <img
                    alt=""
                    className="galerie-logo"
                    src={white_logo}
                    width="300"
                    height="169"
                  />
                </>
              )}
            </Link>

            <div className="navbar-buttons">
              <CustomDropdown
                setNavHoverDim={setNavHoverDim}
                navHoverDim={navHoverDim}
                textColor={textColor}
                background_color={backgroundColor}
                tinted={tintedDropdowns}
                dropdownTitle={"About Us"}
                dropdownLink={"about"}
                clickableTitle={false}
                itemsDict={[
                  { link: "ourstory", title: "Our Story" },
                  { link: "team", title: "Our Team" },
                  { link: "careers", title: "Careers" },
                  { link: "press", title: "In The Press" },
                ]}
              />
              <CustomDropdown
                setNavHoverDim={setNavHoverDim}
                navHoverDim={navHoverDim}
                textColor={textColor}
                background_color={backgroundColor}
                tinted={tintedDropdowns}
                dropdownTitle={"The Collection"}
                dropdownLink={"collections"}
                clickableTitle={false}
                itemsDict={[
                  { link: "portfolio", title: "Portfolio" },
                  {
                    link: "https://corsoresidences.com/",
                    title: "Corso Residences",
                    external: true,
                  },
                  {
                    link: "https://villageparkseniorliving.com/",
                    title: "Village Park",
                    external: true,
                  },
                ]}
              />
              <CustomDropdown
                setNavHoverDim={setNavHoverDim}
                navHoverDim={navHoverDim}
                textColor={textColor}
                background_color={backgroundColor}
                tinted={tintedDropdowns}
                dropdownTitle={"Our Companies"}
                dropdownLink={"companies"}
                clickableTitle={false}
                itemsDict={[
                  { link: "management", title: "Management" },
                  { link: "development", title: "Development" },
                  { link: "capital", title: "Capital" },
                ]}
              />
              <Link
                to="/contact"
                className="navbar-btn"
                style={{ textDecoration: "none" }}
                data-testid="nav-contact-btn"
              >
                <p className="navbar-btn-text" data-testid="nav-contact-btn">
                  contact us
                </p>
              </Link>
            </div>
          </div>
        </>
      ) : (
        <div>
          {" "}
          <div
            className="frame7"
            style={
              // Stays transparent while open: the tint behind it comes from
              // .expanded-container, which extends up under this header.
              expandMenu && backgroundColor === "transparent"
                ? { background: "transparent", borderBottom: "none" }
                : expandMenu
                ? { background: backgroundColor, borderBottom: `1px solid ${borderColor}` }
                : backgroundColor === "transparent"
                ? { background: "transparent", borderBottom: "none" }
                : { background: backgroundColor, borderBottom: "1px solid #D9D9D6" }
            }
          >
            <Link
              to="/ "
              aria-label="galerie-logo"
              data-testid="nav-galerie-logo"
            >
              <img
                alt=""
                className="galerie-logo"
                src={textColor === "white" ? black_logo : white_logo}
                width="16"
                height="9"
              />
            </Link>

            {expandMenu ? (
              <>
                <div
                  className="menu-icon"
                  data-testid="open-hamburger-navbar-btn"
                  onClick={handleExpand}
                >
                  <XIcon size={36} color={textColor} weight="thin" />
                </div>
              </>
            ) : (
              <>
                <div
                  className="menu-icon"
                  data-testid="open-hamburger-navbar-btn"
                  onClick={handleExpand}
                >
                  <ListIcon size={36} color={textColor} weight="thin" />
                </div>
              </>
            )}
          </div>
          {/* AnimatePresence wraps the condition (not the reverse) so the
              panel's exit fade actually runs. */}
          <AnimatePresence>
            {expandMenu && (
              <HamburgerMenuExpanded
                key="hamburger-menu"
                handleExpand={handleExpand}
                backgroundColor={
                  backgroundColor === "transparent"
                    ? "rgba(4, 28, 44, 0.8)"
                    : backgroundColor
                }
                tinted={backgroundColor === "transparent"}
                textColor={textColor}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </>
  );
}
